export type BeheerPage = 'leerkrachten' | 'scholen' | 'data' | 'featureflags' | 'export';

/**
 * Roles granting access per beheer page. Single source of truth for both the route guards and the menu.
 * The order determines where `/beheer` redirects to (the first accessible page).
 */
export const BEHEER_PAGE_ROLES: Record<BeheerPage, string[]> = {
  leerkrachten: ['APPBHR'],
  scholen: ['FBH'],
  data: ['FBH'],
  featureflags: ['TEBH'],
  export: ['FBH'],
};

/** All roles granting access to at least one beheer page. */
export const BEHEER_ROLES: string[] = [...new Set(Object.values(BEHEER_PAGE_ROLES).flat())];
